@import "@/scss/use-bootstrap-mixins.scss";

.opt_in {
  margin-top: 10px;
  display: flex;

  > label {
    font-size: 14px;
    display: flex;
    gap: 12px;
    align-items: center;
    flex: 1;
    cursor: pointer;
  }

  .custom_checkbox {
    position: relative;
    width: 21px;
    height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon_container {
      background-color: #fff;
      width: 21px;
      height: 21px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 11px;
      border: 1px solid #ccc;
      color: #fff;

      svg {
        opacity: 0;
        color: #fff;
        max-height: 1rem !important;
      }
    }

    input[type="checkbox"] {
      display: none;

      &:checked + .icon_container {
        background-color: $primaryOnBackground;
        border-color: $primaryOnBackground;

        svg {
          opacity: 1;
        }
      }
    }
  }

  span {
    font-size: 14px;
    display: block;
  }
}
